<template>
  <div>
    <div class="page-title">編輯作業</div>
    <div class="page-box">
      <jobFrom :formLabelAlign="formLabelAlign" ref="form"></jobFrom>
      <div class="page-notice">請注意：標有 (<span class="star-mark">*</span>) 的為必填項。</div>
      <div class="page-button">
        <!-- 按钮：loading + 禁用 + 文字切换 -->
        <el-button
            type="info"
            @click="onSubmit"
            :loading="submitting"
            :disabled="submitting"
        >
          {{ submitting ? "提交中..." : "提交" }}
        </el-button>
        <el-button type="success" @click="backIndexpage">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeworksDetail, putCopyHomeworks } from '@/api/homeworks'
import jobFrom from "./components/jobFrom.vue";

export default {
  components: { jobFrom },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // 防重复提交状态
      submitting: false,
      formLabelAlign: {
        number: null,
        lang: null,
        gradeId: null,
        grade: {
          name: null,
          price: null,
        },
        startDate: null,
        endDate: null,
        passScore: null,
        homeworkScopes: [
          {
            topicNumber: null,
            practiseNumber: null,
            randomNumber: null,
          },
        ],
        students: [],
      },
    };
  },
  created() {
    this.getHomeworksDetail()
  },
  methods: {
    onSubmit() {
      // 正在提交时直接return，防止重复点击
      if (this.submitting) return;

      // 表单验证
      this.$refs.form.$refs.form.validate((valid) => {
        if (valid) {
          this.putHomeworks();
        }
      });
    },

    async putHomeworks() {
      this.submitting = true; // 开始提交 → 锁定按钮

      try {
        await putCopyHomeworks(this.id, this.formLabelAlign);
        this.$message.success("複製成功");
        this.$router.push({ name: "job" });
      } catch (err) {
        this.$message.error("複製失敗，請重試");
      } finally {
        this.submitting = false; // 提交结束 → 解锁按钮
      }
    },

    backIndexpage() {
      this.$router.push("/job");
    },

    getHomeworksDetail() {
      getHomeworksDetail(this.id).then((v) => {
        this.formLabelAlign = v.data;
        this.formLabelAlign.number = this.formLabelAlign.number + 'copy';
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}
.page-notice{
  margin-top: 20px;
}
</style>